export const deleteHyphen = (targetStr: string = '') => (targetStr ? targetStr.replace(/-/g, '') : '');
export const deleteDot = (targetStr: string = '') => (targetStr ? targetStr.replace(/\./g, '') : '');
